import { datadogRum } from "@datadog/browser-rum";
import { reactPlugin } from "@datadog/browser-rum-react";
import { env } from "@/constants/environment";

export function init() {
  if (env.DATADOG_APPLICATIN_ID && env.DATADOG_CLIENTE_TOKEN_ID) {
    const serviceBaseName = "lexter-copilot-addin-web";

    datadogRum.init({
      applicationId: env.DATADOG_APPLICATIN_ID,
      clientToken: env.DATADOG_CLIENTE_TOKEN_ID,
      // `site` refers to the Datadog site parameter of your organization
      // see https://docs.datadoghq.com/getting_started/site/
      site: "datadoghq.com",
      service: `${serviceBaseName}`,
      env: env.DATADOG_ENV,
      sessionSampleRate: env.DATADOG_SESSION_SAMPLE_RATE,
      sessionReplaySampleRate: env.DATADOG_SESSION_REPLAY_SAMPLE_RATE,
      trackUserInteractions: true,
      trackResources: true,
      trackLongTasks: true,
      defaultPrivacyLevel: "mask",
      version: env.DATADOG_VERSION,
      allowedTracingUrls: ["/https://.*.lexter.ai/"],
      enableExperimentalFeatures: ["feature_flags"],
      betaPlugins: [reactPlugin({ router: true })],
      beforeSend: (event) => {
        // Drop a universally-benign browser warning that otherwise inflates the
        // RUM error count without indicating any real problem. We deliberately do
        // NOT filter Stripe load errors here: after the on-demand loader change
        // those only fire for real payment sessions and are emitted as the
        // `stripe_load_failed` action, so they remain a meaningful signal.
        const isResizeObserverNoise = event.type === "error" && event.error.message.includes("ResizeObserver loop");
        return !isResizeObserverNoise;
      },
    });
  }
}
